import { MediaAgencyBean, MediaAgencyControllerApi, ItemResponseMediaAgencyBeanObject, ListResponseMediaAgencyBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class MediaAgencyApi extends BaseApi {
    api: MediaAgencyControllerApi

    constructor() {
        super()
        this.api = new MediaAgencyControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(size: number = 20, page: number = 1, sort, search, active): Promise<ListResponseMediaAgencyBean> {
        return this.call(() => this.api.mediaAgencyList(search, active, { query: { size, page, sort } }))
    }

    async all(): Promise<ListResponseMediaAgencyBean> {
        return this.call(() => this.api.mediaAgencyList())
    }

    async create(mediaAgency: MediaAgencyBean): Promise<ItemResponseMediaAgencyBeanObject> {
        return this.call(() => this.api.createMediaAgency(mediaAgency))
    }

    async edit(id: any, mediaAgency: MediaAgencyBean): Promise<ItemResponseMediaAgencyBeanObject> {
        return this.call(() => this.api.editMediaAgency(mediaAgency, id))
    }

    async view(id: any): Promise<ItemResponseMediaAgencyBeanObject> {
        return this.call(() => this.api.mediaAgency(id))
    }

    async delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteMediaAgency(id))
    }

    async activate(id: any): Promise<void> {
        return this.call(() => this.api.activateMediaAgency(id))
    }
}

const mediaAgencyApi = new MediaAgencyApi()
export default mediaAgencyApi


// WEBPACK FOOTER //
// ./src/component/app/mediaAgency/MediaAgencyApi.ts